var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHappyMealNew = function SvgHappyMealNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00B3C6",
    clipPath: "url(#happyMealNew_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.053 6.293A2.67 2.67 0 0 0 12 3.753V.667a.666.666 0 1 0-1.333 0v3.086a1.28 1.28 0 0 1-.62 1.1V.667a.667.667 0 0 0-1.334 0v4.186a1.28 1.28 0 0 1-.62-1.1V.667a.667.667 0 0 0-1.333 0V3.76a2.63 2.63 0 0 0 1.953 2.527v1.88c.4-.336.85-.606 1.334-.8zM2.94 0A2.94 2.94 0 0 0 0 2.927V4.26a2.95 2.95 0 0 0 2.413 2.873v7.62a.667.667 0 1 0 1.334 0V7.067a2.94 2.94 0 0 0 2.126-2.82V2.913A2.933 2.933 0 0 0 2.94 0m12.987 12a4 4 0 1 0-8 .004 4 4 0 0 0 8-.004m-1.62-.993-1.94 2.586a1.165 1.165 0 0 1-1.754.127l-1-1.007a.667.667 0 0 1 .94-.94l.867.867 1.82-2.433a.667.667 0 0 1 1.067.8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "happyMealNew_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgHappyMealNew;